export default [
  {
    path: '/content/create-content',
    name: 'create-content',
    component: () => import('@/views/pages/komed/content/CreateContent.vue'),
    meta: {
      name: 'create-content',
      resource: 'Buat Konten',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Buat Konten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/content/credit-history',
    name: 'credit-history',
    component: () => import('@/views/pages/komed/content/CreditHistory.vue'),
    meta: {
      name: 'credit-history',
      resource: 'Riwayat Kredit',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Riwayat Kredit',
          active: true,
        },
      ],
    },
  },
]
